module.exports = __webpack_public_path__ + "static/media/ATRICRYPTO.a43a8f2a.png";